import { createFileRoute } from "@tanstack/react-router";
import { GoogleReviewPage, buildGoogleReviewHead } from "@/components/shop/GoogleReviewPage";
import { googleReviewDictVi } from "@/lib/shop/products/google-review";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/google-review")({
  head: () => ({
    ...buildGoogleReviewHead(googleReviewDictVi),
    links: alternateLinkList("/shop/google-review", "vi"),
  }),
  component: () => <GoogleReviewPage dict={googleReviewDictVi} />,
});